import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectBoilerModels } from 'console/redux/boiler-models/selectors';
import { BoilerAdapter } from 'z3k-config';
import * as lodash from 'lodash';
import { removeNulls } from 'utils';
import { selectorSelectedDevice } from 'entities/device/lib';
import { getDeviceSpecV2 } from 'z3k-parser/model/device-spec/z3k-feature-flags';
export const boiler_model_filter_protocol_for_device_spec = () => {
    const selected_device = useAppSelector(selectorSelectedDevice);
    const { boiler_types, boiler_models } = useAppSelector(selectBoilerModels);
    const device_type = selected_device?.device_type?.code;
    const device_spec = getDeviceSpecV2(device_type, selected_device?.hardware_type?.code);
    if (device_type === 'CONNECT_ESP' && device_spec) {
        const ba_allow_types = BoilerAdapter.getTypeOptions(device_spec);
        const filter_on_device_spec = removeNulls(boiler_types.map((model) => {
            if (model.protocol) {
                return lodash.some(ba_allow_types, { value: model.protocol })
                    ? model
                    : null;
            }
            return model;
        }));
        return removeNulls(filter_on_device_spec.map((el) => boiler_models.find((boiler_models) => boiler_models.value === el.zont_id)));
    }
    else {
        return boiler_models;
    }
};
